import script from "./courseInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./courseInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./courseInfoAdd.vue?vue&type=style&index=0&id=30980f3e&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30980f3e"]])

export default __exports__